import { markdownToSafeHtml } from "../editor/markdownPreview.js";
import aboutMarkdown from "../content/the-day-we-stopped-writing-code.md?raw";
import usersGuideMarkdown from "../../demo/NULLAPAD_USERS_GUIDE.md?raw";
import maxGuideMarkdown from "../content/max-language-guide.md?raw";

interface TabDef {
  label: string;
  markdown: string;
}

function escapeMaxHtml(s: string): string {
  return s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
}

/** Open the dialog with tabs for multiple markdown sections. */
export function openTabbedMarkdownDialog(tabs: TabDef[], titleText: string): void {
  const dlg = document.createElement("dialog");
  dlg.className = "npp-dialog npp-dialog-search npp-dialog-about-nullapad";

  const form = document.createElement("div");
  form.className = "npp-dialog-form npp-dialog-search-form";

  const title = document.createElement("h2");
  title.className = "npp-dialog-title";
  title.textContent = tabs.length ? tabs[0]!.label : titleText;

  let tabHtml = "";
  if (tabs.length > 1) {
    tabHtml = `<div class="npp-about-tab-bar">${tabs
      .map((t, i) => `<button type="button" class="npp-about-tab-btn" data-tab="${i}">${escapeMaxHtml(t.label)}</button>`)
      .join("")}</div>`;
  }

  const bodies = tabs.map((t) => markdownToSafeHtml(t.markdown));
  const innerHtml = tabs.length === 1
    ? bodies[0]!
    : bodies.map((b, i) => `<div class="npp-about-tab"${i > 0 ? " hidden" : ""}>${b}</div>`).join("");

  const body = document.createElement("div");
  body.className = "npp-about-nullapad-body";
  body.innerHTML = tabHtml + innerHtml;

  // Tab switching logic
  if (tabs.length > 1) {
    const btns = body.querySelectorAll<HTMLButtonElement>("button.npp-about-tab-btn");
    const tabs_els = body.querySelectorAll<HTMLDivElement>("div.npp-about-tab");
    btns.forEach((btn, idx) => {
      btn.addEventListener("click", () => {
        btns.forEach((b) => b.classList.remove("active"));
        btn.classList.add("active");
        tabs_els.forEach((tc, ti) => {
          if (ti === idx) tc.removeAttribute("hidden");
          else tc.setAttribute("hidden", "");
        });
        title.textContent = tabs[idx]!.label;
      });
      if (idx === 0) btn.classList.add("active");
    });
  }

  const actions = document.createElement("div");
  actions.className = "npp-dialog-actions";
  const closeBtn = document.createElement("button");
  closeBtn.type = "button";
  closeBtn.textContent = "Close";
  closeBtn.addEventListener("click", () => {
    dlg.close();
    dlg.remove();
  });
  actions.appendChild(closeBtn);

  form.append(title, body, actions);
  dlg.appendChild(form);
  document.body.appendChild(dlg);

  dlg.addEventListener("cancel", (e) => {
    e.preventDefault();
    dlg.close();
    dlg.remove();
  });

  dlg.showModal();
  closeBtn.focus();
}

/** Scrollable "About" modal with the bundled NullaPad story + MAX Language Guide. */
export function openAboutNullaPadDialog(): void {
  openTabbedMarkdownDialog([
    { label: "About NullaPad", markdown: aboutMarkdown },
    { label: "MAX Language Guide", markdown: maxGuideMarkdown },
  ], "About NullaPad");
}

/** Scrollable modal with bundled NullaPad Users Guide + MAX Language Guide. */
export function openNullaPadUsersGuideDialog(): void {
  openTabbedMarkdownDialog([
    { label: "Users Guide", markdown: usersGuideMarkdown },
    { label: "MAX Language Guide", markdown: maxGuideMarkdown },
  ], "NullaPad Users Guide");
}

/** Just the MAX Language Guide. */
export function openMaxLanguageGuideDialog(): void {
  openTabbedMarkdownDialog([
    { label: "MAX Language Guide", markdown: maxGuideMarkdown },
  ], "MAX Language Guide");
}
